import rivets from 'rivets';
/* eslint-disable */
/**
 * fix to make two way data-binding work in IE7 an IE8
 */

/* jshint ignore:start */

/* istanbul ignore next */
var __indexOf = [].indexOf || function (item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

/* istanbul ignore next */
rivets.binders.value = {
    publishes: true,
    bind: function (el) {
        this.event = el.tagName === 'SELECT' ? 'change' : 'textchange';
        return $(el).on(this.event, this.publish);
    },
    unbind: function (el) {
        return $(el).off(this.event, this.publish);
    },
    routine: function (el, value) {
        var o, _i, _len, _ref, _ref1, _ref2, _results;
        if (window.$ != null) {
            el = $(el);
            if ((value != null ? value.toString() : void 0) !== ((_ref = el.val()) != null ? _ref.toString() : void 0)) {
                return el.val(value != null ? value : '');
            }
        } else {
            if (el.type === 'select-multiple') {
                if (value != null) {
                    _results = [];
                    for (_i = 0, _len = el.length; _i < _len; _i++) {
                        o = el[_i];
                        _results.push(o.selected = (_ref1 = o.value, __indexOf.call(value, _ref1) >= 0));
                    }
                    return _results;
                }
            } else if ((value != null ? value.toString() : void 0) !== ((_ref2 = el.value) != null ? _ref2.toString() : void 0)) {
                return el.value = value != null ? value : '';
            }
        }
    }
};
/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/rivets/ieFix.js
 **/